"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.positions = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _Common = require("./Common.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var positions = {
  right: 'right',
  left: 'left'
};
exports.positions = positions;

var InputIcons = _react.default.memo(function (_ref) {
  var errors = _ref.errors,
      focused = _ref.focused,
      icons = _ref.icons,
      position = _ref.position,
      zeroPadding = _ref.zeroPadding;
  var isRight = position === positions.right; // this allows us to force icons to conform to the desired styling

  var iconColorTheme = 'default'; // start with default grey

  if (focused) {
    iconColorTheme = 'primary';
  } // if focused, then we apply the primary


  if (errors.length > 0) {
    iconColorTheme = 'danger';
  } // error state trumps all


  return /*#__PURE__*/_react.default.createElement(_Common.IconsWrapper, {
    isRight: isRight,
    zeroPadding: zeroPadding
  }, isRight && errors.length > 0 ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    key: "input-error-icon",
    dataTestId: "input-error-icon",
    iconName: "exclamation-triangle",
    colorTheme: "danger"
  }) : null, icons && icons.map(function (elem) {
    return _react.default.cloneElement(elem, {
      key: elem.key || elem.props.iconName,
      colorTheme: iconColorTheme
    });
  }));
});

InputIcons.propTypes = {
  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Flag utilized to trigger correct styling on focused inputs */
  focused: _propTypes.default.bool,

  /** array of Cake Icons to display in the given location */
  icons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Positioning flag - either 'right' or 'left' (undefined == 'left') */
  position: _propTypes.default.oneOf([positions.left, positions.right]),

  /** flag to partially remove default padding - used internally */
  zeroPadding: _propTypes.default.bool
};
InputIcons.defaultProps = {
  errors: [],
  focused: false,
  icons: [],
  position: positions.left,
  zeroPadding: false
};
var _default = InputIcons;
exports.default = _default;